export enum MessageTypes {
    Success = 'success',
    Notice = 'notice',
    Warning = 'warning',
    Error = 'error',
    None = ''
}
export interface Message {
    text: string;
    type: MessageTypes;
}



// WEBPACK FOOTER //
// ./src/app/message.ts